export const RETURN_URL_PARAM = "returnUrl";

/** Only allow same-origin relative paths to prevent open redirects. */
export const getSafeReturnUrl = (
  value: string | null | undefined
): string | null => {
  if (!value) return null;
  if (!value.startsWith("/") || value.startsWith("//")) return null;
  return value;
};

export const buildLoginPathWithReturnUrl = (
  loginPath: string,
  returnUrl: string
): string => {
  const params = new URLSearchParams({ [RETURN_URL_PARAM]: returnUrl });
  return `${loginPath}?${params.toString()}`;
};
